import React, { Component } from 'react'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import LoanDocumentNavUI from './LoanDocumentNavUI.js'

class LoanDocumentNavSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      directorList: null,
      coBorrowerExists: false
    }
  }

  render() {
    let visibility = this.getDocumentTabVisibility()
    return (
      <LoanDocumentNavUI
        loan={this.props.loan}
        documentType={this.props.documentType}
        showEscrowAgreement={visibility.showEscrowAgreement}
        showPledgeAgreement={visibility.showPledgeAgreement}
        showPledgeCumGuarantee={visibility.showPledgeCumGuarantee}
        showNDU={visibility.showNDU}
        showCoBorrowerNDU={visibility.showCoBorrowerNDU}
        showPersonalGuarantee={visibility.showPersonalGuarantee}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getDirectors(context)
    this.getProperties(context)
  }

  getDirectors(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.loan.loanId}/users`,
      cacheKey: CacheKeys.LoanDirectors(this.props.loan.loanId),
      callback: this.getDirectorsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getDirectorsCallback = (response) => {
    this.setState({ directorList: response.accountUserList || [] })
  }

  getProperties(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.loan.loanId}/properties`,
      cacheKey: CacheKeys.LoanProperties(this.props.loan.loanId),
      callback: this.getPropertiesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getPropertiesCallback = (response) => {
    let propertyList = response.loanPropertyList
    let coBorrowerExists = propertyList.some(
      p =>
        p.propertyCode === 'co_borrower_exists' &&
        (p.propertyValue === '1')
    )
    this.setState({ coBorrowerExists })
  }

  isPledge = (d) => d.sharePledgedPercent > 0
  isNdu = (d) => d.nduPercent > 0
  isGuarantor = (d) => d.guarantor === true

  getDocumentTabVisibility = () => {
    let loan = this.props.loan
    let directorList = this.state.directorList
    let coBorrowerExists = this.state.coBorrowerExists
    let showEscrowAgreement = loan.escrow === 'b2b' || loan.escrow === 'b2c'
    if (!directorList || directorList.length === 0) {
      return {
        showEscrowAgreement: false,
        showPledgeAgreement: false,
        showPledgeCumGuarantee: false,
        showNDU: false,
        showCoBorrowerNDU: false,
        showPersonalGuarantee: false
      }
    }
    let hasPledge = directorList.some(this.isPledge)
    let hasNDU = directorList.some(this.isNdu)
    let hasGuarantee = directorList.some(this.isGuarantor)

    let showNDU = hasNDU
    let showCoBorrowerNDU = hasNDU && coBorrowerExists
    let showPledgeAgreement = hasPledge && (!hasGuarantee || directorList.some(d => this.isPledge(d) && !this.isGuarantor(d)))
    let showPersonalGuarantee = hasGuarantee && (!hasPledge || directorList.some(d => this.isGuarantor(d) && !this.isPledge(d)))
    let showPledgeCumGuarantee = hasPledge && hasGuarantee && directorList.some(d => this.isPledge(d) && this.isGuarantor(d))

    return {
      showEscrowAgreement,
      showPledgeAgreement,
      showPledgeCumGuarantee,
      showNDU,
      showCoBorrowerNDU,
      showPersonalGuarantee
    }
  }
}

export default LoanDocumentNavSF
